import React, { useState } from 'react';
import { registrarTecnico } from '../servicios/api'; // Importar la nueva función

const ModalCrearTecnico = ({ isOpen, onClose, onTecnicoCreado }) => {
  const [formData, setFormData] = useState({
    nombre_usuario: '',
    correo_electronico: '',
    contrasena: '',
    confirmar_contrasena: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.nombre_usuario || !formData.correo_electronico || !formData.contrasena || !formData.confirmar_contrasena) {
      setError('Todos los campos son obligatorios.');
      return;
    }

    if (formData.contrasena !== formData.confirmar_contrasena) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      const response = await registrarTecnico({
        nombre_usuario: formData.nombre_usuario,
        correo_electronico: formData.correo_electronico,
        contrasena: formData.contrasena,
      });

      if (response.exito) {
        alert(response.mensaje);
        if (onTecnicoCreado) {
          onTecnicoCreado(response.tecnico); // Asumiendo que la API devuelve el técnico creado
        }
        onClose();
      } else {
        setError(response.mensaje || 'Ocurrió un error desconocido al registrar el técnico.');
      }
    } catch (error) {
      console.error("Error al registrar técnico:", error);
      const errorMessage = error.response && error.response.data && error.response.data.mensaje
        ? error.response.data.mensaje
        : "Error al conectar con el servidor para registrar el técnico.";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4">
      <div className="form-container bg-slate-900 rounded-lg shadow-xl w-full max-w-md max-h-[90vh] flex flex-col overflow-hidden border border-slate-700">
        <div className="form-header bg-slate-800 p-4 border-b border-slate-700 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-white">Crear nuevo Técnico</h2>
          <button onClick={onClose} className="close-btn text-gray-400 hover:text-white text-2xl leading-none">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="form-content p-6 overflow-y-auto">
          <div className="mb-4">
            <label htmlFor="nombre_usuario" className="block text-sm font-medium text-gray-300 mb-1">Nombre de Usuario</label>
            <input
              type="text"
              id="nombre_usuario"
              name="nombre_usuario"
              value={formData.nombre_usuario}
              onChange={handleChange}
              className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="correo_electronico" className="block text-sm font-medium text-gray-300 mb-1">Correo Electrónico</label>
            <input
              type="email"
              id="correo_electronico"
              name="correo_electronico"
              value={formData.correo_electronico}
              onChange={handleChange}
              className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="contrasena" className="block text-sm font-medium text-gray-300 mb-1">Contraseña</label>
            <input
              type="password"
              id="contrasena"
              name="contrasena"
              value={formData.contrasena}
              onChange={handleChange}
              className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          <div className="mb-6">
            <label htmlFor="confirmar_contrasena" className="block text-sm font-medium text-gray-300 mb-1">Confirmar Contraseña</label>
            <input
              type="password"
              id="confirmar_contrasena"
              name="confirmar_contrasena"
              value={formData.confirmar_contrasena}
              onChange={handleChange}
              className="w-full p-2 border border-slate-700 rounded-md text-sm bg-slate-800 text-white focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

          <div className="form-actions flex justify-end gap-3 pt-4 border-t border-slate-700">
            <button type="button" onClick={onClose} className="btn btn-secondary bg-gray-600 text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-gray-700">Cancelar</button>
            <button type="submit" className="btn btn-primary bg-blue-600 text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-blue-700" disabled={loading}>
              {loading ? 'Registrando...' : 'Registrar Técnico'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalCrearTecnico;